"use client"

import { useState, type ReactNode } from "react"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"

import { makeQueryClient } from "@/lib/api/query-client"
import { Toaster } from "@/components/ui/toaster"
import { BfcacheRevalidator } from "@/components/bfcache-revalidator"

export function Providers({ children }: { children: ReactNode }) {
  const [client] = useState(() => makeQueryClient())
  return (
    <QueryClientProvider client={client}>
      <BfcacheRevalidator />
      {children}
      <Toaster />
      {process.env.NODE_ENV !== "production" && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  )
}
